/**CORE LIBRARIES IMPORT */
import React from "react";
import { motion } from "framer-motion";

/**COMPONENTS / HOOKS IMPORT */
import BrandLogo from "./BrandLogo";
import Icon from "./Icon";
import VenuePhoto from "./VenuePhoto";
import useInViewOnce from "../hooks/useInViewOnce";

/** Template "About The Club" section, now "Discover Our Venue". */
const AboutUs = () => {
  const [h2Ref, inView] = useInViewOnce(0.5);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }
  };


  const slideRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }
  };

  const features = [
    { icon: "flame", label: "Wood-Fired Pizza" },
    { icon: "grill", label: "Grill" },
    { icon: "celebrate", label: "Events" },
    { icon: "catering", label: "Catering" },
  ];

  return (
    <section id="venue" className="about-section" aria-labelledby="venue-heading" tabIndex={-1}>
      <div className="about-container">

        {/* Left Section */}
        <div className="about-left">
           <h2 id="venue-heading" ref={h2Ref} className={`section-heading ${inView ? "in-view" : ""}`}>
        Discover Our Venue
      </h2>

          <motion.p
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={fadeUp}
            className="section-text"
          >
            The Grey Wolf is located inside Lyster's Pub in Harold's Cross, Dublin. Look for the gold Lyster's lettering and The Grey Wolf sign above the door, then step inside for wood-fired pizza and food from the grill. Join us for a relaxed meal, a special event or a private celebration.
          </motion.p>

          <motion.ul
            className="about-features"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.15 } }
            }}
          >
            {features.map((feature) => (
              <motion.li
                className="feature"
                key={feature.label}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
                }}
              >
                <div className="icon-wrapper">
                  <div className="icon-circle">
                    <Icon name={feature.icon} size={40} />
                  </div>
                </div>
                <span>{feature.label}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        {/* Right Section */}
        <motion.div
          className="about-right"
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={slideRight}
        >
          <BrandLogo size={420} className="about-emblem" />
        </motion.div>

      </div>

      {/* Full-width venue photograph */}
      <motion.div
        className="venue-band"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <VenuePhoto
          slot="about"
          sizes="(min-width: 1400px) 1320px, 100vw"
          caption="The Grey Wolf × Lyster's Pub · Harold's Cross, Dublin"
        />
      </motion.div>
    </section>
  );
};

export default AboutUs;
